const integerFormatter = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});

const compactFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export const formatNumber = (value: number): string =>
  integerFormatter.format(value);

export const formatCompactNumber = (value: number): string =>
  compactFormatter.format(value);
